<p-speedDial *ngIf="hasAccess" class="speeddial-linear-demo cursor-move" [model]="speedDialitems" direction="left" [radius]="80" showIcon="pi pi-cog"
  type="semi-circle" buttonClassName="p-button-secondary p-button-outlined"
  [style]="{'position':'relative', 'scale':'0.7'}" transitionDelay="80"
  (onClick)="getDriverSpeedDial(card.driver.driver_id, orderInfo.order_id || 0)" />

<p-dialog [(visible)]="showNotesDialog" [modal]="true" [style]="{width: '450px'}">
  <div class="flex flex-column gap-3">
    <textarea pInputTextarea [(ngModel)]="currentNotes" [rows]="5" [autoResize]="true" class="w-full h-6rem"
      placeholder="Enter notes for this load...">
    </textarea>
    <div class="flex justify-content-end gap-2">
      <button pButton label="Cancel" class="p-button-text" (click)="showNotesDialog = false"></button>
      <button pButton label="Save" (click)="saveNotes()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showFormDialog" [modal]="true" [style]="{width: '450px', borderRadius: '8px'}" [closeOnEscape]="true"
  [closable]="true" [showHeader]="false" styleClass="washout-dialog">

  <ng-template pTemplate="body">
    <div class="flex flex-column align-items-center p-4 gap-4">
      <i class="pi pi-question-circle text-5xl text-primary"></i>
      <p class="text-2xl font-semibold m-0 text-center">
        Wash Out Needed?
      </p>
      <p class="text-sm text-500 text-center m-0">
        Select the appropriate wash out type for this trailer
      </p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex flex-column justify-content-center w-full gap-3 px-5 pb-5">
      <!-- Main options in a row -->
      <div class="flex gap-3">
        <button pButton label="Plastic" icon="pi pi-box" 
          class="p-button-primary flex-1 p-3 font-semibold" 
          [style]="{borderRadius: '6px'}"
          (click)="prepareTrailerNumber('plastic')">
        </button>
        <button pButton label="Other" icon="pi pi-ellipsis-h" 
          class="p-button-info flex-1 p-3 font-semibold text-900"
          [style]="{borderRadius: '6px', color: 'black'}"
          (click)="prepareTrailerNumber('other')">
        </button>
      </div>
      
      <!-- Skip option below -->
      <button pButton label="Skip" icon="pi pi-times" 
        class="p-button-outlined p-button-secondary p-3 font-semibold"
        [style]="{borderRadius: '6px'}"
        (click)="showFormDialog = false">
      </button>
    </div>
  </ng-template>
</p-dialog>


<p-dialog header="Split Load Assignment" [(visible)]="showSplitDialog" [style]="{width: '400px', height: '400px'}"
  [modal]="true" styleClass="p-fluid">

  <div class="grid">
    <!-- Driver Selection -->
    <div class="col-12 mb-3">
      <label for="driver" class="block text-900 font-medium mb-2">
        Who would you like to split this load with?
      </label>
      <p-dropdown id="driver" [(ngModel)]="selectedDriver" [options]="driverOptions" placeholder="Select a driver"
        [style]="{'width': '100%'}" (onChange)="onDriverSelect($event)">
        <ng-template pTemplate="selectedItem" let-driver>
          {{driver.driver.first_name}} {{driver.driver.last_name}}
        </ng-template>
        <ng-template pTemplate="item" let-driver>
          {{driver.driver.first_name}} {{driver.driver.last_name}}
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Role Selection -->
    <div class="col-12">
      <label for="role" class="block text-900 font-medium mb-2">
        What part of the load will this driver be fulfilling?
      </label>
      <p-dropdown id="role" [(ngModel)]="selectedRole" [options]="[
            {label: 'Pickup', value: 'pickup'},
            {label: 'Drop-off', value: 'dropoff'}
          ]" placeholder="Select role" [style]="{'width': '100%'}" (onChange)="onRoleSelect($event)"></p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancel" styleClass="p-button-text" (click)="showSplitDialog = false"></p-button>
      <p-button label="Confirm" (click)="saveRole()" [disabled]="!selectedDriver || !selectedRole"></p-button>
    </div>
  </ng-template>
</p-dialog>

<app-send-dispatch #dispatchDialog></app-send-dispatch>